import React from "react";
import { useField, useFormikContext } from "formik";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { Select } from "antd";
import { get } from 'lodash'
const { Option } = Select;


const getFieldCSSClasses = (touched, errors) => {
  const classes = []; // ["form-control", "form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function EmployeeSelect({
  label,
  name,
  employees,
  multiple = false,
  customFeedbackLabel,
  withFeedbackLabel = true,
}) {
  const { setFieldValue, setFieldTouched, errors, touched } = useFormikContext();
  const [field] = useField(name);

  const touchedResult = get(touched, field.name);
  const errorsResult = get(errors, field.name);

  const filterOption = (input, option) => {
    const searchQuery = input.toLowerCase();
    const isNumber = /^-?[\d.]+(?:e-?\d+)?$/.test(searchQuery);

    if (isNumber) {
      const employee = employees.find((e) => e.id === option.value);
      return (employee?.internal_id ?? '').toString().startsWith(searchQuery);
    }

    return (option?.name ?? '').toLowerCase().startsWith(searchQuery)
  }

  return (
    <>
      {label && (
        <div className="d-flex justify-content-between align-items-center mb-1">
          <label className="mb-0">{label}</label>
          {multiple && (
            <div className="d-flex" style={{ gap: "10px" }}>
              <span
                className="text-primary cursor-pointer text-hover-underline"
                style={{ fontSize: "11px", cursor: "pointer" }}
                onClick={() => setFieldValue(field.name, employees?.map((e) => e.id) || [])}
              >
                Select All
              </span>
              <span
                className="text-danger cursor-pointer text-hover-underline"
                style={{ fontSize: "11px", cursor: "pointer" }}
                onClick={() => setFieldValue(field.name, [])}
              >
                Deselect All
              </span>
            </div>
          )}
        </div>
      )}
      <Select
        showSearch
        allowClear
        size='large'
        style={{ width: '100%' }}
        value={field.value}
        {...multiple && { mode: "multiple"}}
        filterOption={filterOption}
        onChange={(value) => setFieldValue(field.name, value)}
        onBlur={() => setFieldTouched(field.name, true)}
        className={getFieldCSSClasses(touchedResult, errorsResult)}
        status={errorsResult ? 'error' : ''}
      >
        {employees?.map((employee) => {
          return (
            <Option value={employee.id} key={employee.id} name={employee.name}>
              {employee.name}
            </Option>
          );
        })}
      </Select>
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errorsResult}
          touched={touchedResult}
          label={label}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
